<template>
  <section class="w-full bg-white">
    <!-- <h1 class="text-transpurple font-bold text-48 text-center leading-73">
      Cases by States
    </h1> -->
    <div class="flex">
      <DownloadChart
        @click="downloadCanvas('agenciesChart', 'titleAgenciesChart')"
      />
    </div>
    <div ref="agenciesChart">
      <h3 ref="titleAgenciesChart" class="hidden mt-4 text-lg">
        Corruption Cases by Agency
      </h3>
      <BarChart
        :width="0"
        :height="height"
        :chart-data="chartdata"
        :options="options"
      />
    </div>
  </section>
</template>

<script>
import BarChart from "./Charts/BarChart";
// import HorizontalBar from "./Charts/HorizontalBar";
import axios from "axios";

export default {
  name: "StatesCases",
  components: {
    BarChart
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      agencies: []
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    counts() {
      return this.agencies.map(a => a.cases_count);
    },
    names() {
      return this.agencies.map(a => a.name);
    },
    shortnames() {
      return this.agencies.map(a => a.shortname);
    },
    chartdata() {
      return {
        labels: this.shortnames,
        datasets: [
          {
            label: "Cases by Agency",
            backgroundColor: "#0b2b26",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.counts
          }
        ]
      };
    },
    options() {
      return {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getAgencyCount();
      }
    }
  },
  mounted() {
    this.getAgencyCount();
  },
  methods: {
    getAgencyCount() {
      axios
        .get(`${window.host}/api/cases-agency`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.agencies = response.data;
          }
        });
    }
  }
};
</script>

<style scoped>
section {
  .svg {
    width: 100vw;
  }
}
</style>
